import classNames from 'classnames'
import Popover from '../../Popover'
import { AccessAccount } from '../types'
import AssignAnotherOwner from './AssignAnotherOwner'

interface IOwnerMoreActions {
  ownerId: string
  onOwnerChange?: (newOwner: AccessAccount) => void
  disabled?: boolean
}

const OwnerMoreActions = ({
  disabled = false,
  onOwnerChange,
  ...rest
}: IOwnerMoreActions) => {
  return onOwnerChange ? (
    <Popover
      popperPlacement="bottom-end"
      disabled={disabled}
      button={
        <i
          className={classNames([
            'far fa-ellipsis text-2xl px-3',
            {
              'text-primary': !disabled,
              'text-oxford-gray-300': disabled,
            },
          ])}
        />
      }
      content={({ close }) => (
        <AssignAnotherOwner
          onOwnerChange={onOwnerChange}
          onClose={close}
          {...rest}
        />
      )}
    />
  ) : null
}

export default OwnerMoreActions
